import moment from "moment";
import { formatToCurrency } from "utils/currency";
import logo from "shared/branding/logo.svg";

import { statementDetails, PayType } from "../types";

interface PDFHeaderProps {
  billingDetails: statementDetails;
  totalAmount?: number;
  payType: PayType;
}

export const PDFHeader = ({
  billingDetails,
  totalAmount,
  payType
}: PDFHeaderProps) => {
  return (
    <div className="mx-auto max-w-2xl p-6 print:relative hidden print:inline sm:rounded-lg">
      <img alt="Boom logo" className="h-5 w-[59px] mb-2.5" src={logo} />
      <h3 className="text-center text-base mb-2.5 font-bold capitalize text-content-1000">
        Statement
      </h3>
      <div className="flex justify-between">
        <div>
          <h2 className="mb-2.5 text-xs font-bold text-content-1000">
            Boompay Inc.
          </h2>
          <p className="text-xxs text-content-1000 font-medium">
            1401 Lavaca St. #1036
          </p>
          <p className="text-xxs text-content-1000 font-medium">
            Austin, TX 78701
          </p>
          <p className="text-xxs text-content-1000 font-medium">
            United States
          </p>
        </div>
        <div className="text-right">
          <ul className="list-none space-y-1">
            <li className="text-xxs font-bold text-content-1000 capitalize">
              Statement #:{" "}
              <span className="text-content-300">{billingDetails.id}</span>
            </li>
            <li className="text-xxs font-bold text-content-1000">
              Status:{" "}
              <span className="text-content-300">
                {["paid", "settled"].includes(billingDetails.status)
                  ? "Paid"
                  : "Unpaid"}
              </span>
            </li>
            <li className="text-xxs font-bold capitalize text-content-1000">
              Statement Date:{" "}
              <span className="text-content-300">
                {moment(billingDetails.created_at).format("MMM DD, YYYY")}
              </span>
            </li>
            <li className="text-xxs font-bold capitalize text-content-1000">
              {`Total ${payType === PayType.Payin ? "charge" : "payout"}: `}
              <span className="text-content-300">
                {formatToCurrency({
                  cents: Math.abs(totalAmount || 0),
                  currency: "USD"
                })}
              </span>
            </li>
          </ul>
        </div>
      </div>
      {billingDetails.partner ? (
        <div className="mt-4 border-t border-alpha-40 pt-4">
          <h2 className="text-xs font-medium text-content-1000">
            {billingDetails.partner.address.address1}
          </h2>
          <p className="text-sm">{billingDetails.partner.address.address1}</p>
          <p className="text-sm">
            {billingDetails.partner.address.city},{" "}
            {billingDetails.partner.address.state}{" "}
            {billingDetails.partner.address.zip}{" "}
          </p>
          <p className="text-sm">{billingDetails.partner.address.country}</p>
        </div>
      ) : null}
      <div className="border-t border-alpha-40 mt-4 pt-4">
        <h2 className="mb-2.5 text-xxs font-medium text-content-1000">
          Boompay Inc.
        </h2>
        <p className="text-xxs text-content-1000 font-medium">
          1401 Lavaca St. #1036
        </p>
        <p className="text-xxs text-content-1000 font-medium">
          Austin, TX 78701
        </p>
        <p className="text-xxs text-content-1000 font-medium">United States</p>
      </div>
    </div>
  );
};
